import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeStyle as _normalizeStyle, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "tag-list-collapsible" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_popover = _resolveComponent("el-popover")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tagList, ({tagId, color, name}, index) => {
      return (_openBlock(), _createElementBlock(_Fragment, { key: tagId }, [
        (index < _ctx.displayLimitCount)
          ? (_openBlock(), _createBlock(_component_el_tag, {
              key: 0,
              class: "tag-list-collapsible__item",
              color: color,
              size: "small",
              effect: "dark",
              style: _normalizeStyle(_ctx.getTagStyle(color))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(name), 1 /* TEXT */)
              ]),
              _: 2 /* DYNAMIC */
            }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["color", "style"]))
          : _createCommentVNode("v-if", true)
      ], 64 /* STABLE_FRAGMENT */))
    }), 128 /* KEYED_FRAGMENT */)),
    (_ctx.hasDisplayPopoverTags)
      ? (_openBlock(), _createBlock(_component_el_popover, {
          key: 0,
          placement: _ctx.placement,
          "popper-class": "tag-list-collapsible__popover-content"
        }, {
          reference: _withCtx(() => [
            _createVNode(_component_el_tag, {
              type: "info",
              size: "small",
              effect: "dark"
            }, {
              default: _withCtx(() => [
                _createTextVNode(" +" + _toDisplayString(_ctx.popoverTagList.length), 1 /* TEXT */)
              ]),
              _: 1 /* STABLE */
            })
          ]),
          default: _withCtx(() => [
            _createElementVNode("div", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.popoverTagList, ({ tagId, color, name }) => {
                return (_openBlock(), _createBlock(_component_el_tag, {
                  key: tagId,
                  color: color,
                  size: "small",
                  effect: "dark"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(name), 1 /* TEXT */)
                  ]),
                  _: 2 /* DYNAMIC */
                }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["color"]))
              }), 128 /* KEYED_FRAGMENT */))
            ])
          ]),
          _: 1 /* STABLE */
        }, 8 /* PROPS */, ["placement"]))
      : _createCommentVNode("v-if", true)
  ]))
}